import {asBooleanWithDefaultValue} from './asBooleanWithDefaultValue';

export const asBoolean = asBooleanWithDefaultValue();
